import { ModuleID } from '../types'
import { ISupervisorModule, ISupervisorModuleOptions } from './types'
import { deepMergeObject } from '@aytm/lib/common/object'

const options: ISupervisorModuleOptions = {
  openEndedLogger: {
    enabled: true,
    intervalMs: 1000,
    trigger: 64,
    eventType: 'oe-paste'
  }
}

let moduleLoaded = false
const SupervisorModule: ISupervisorModule = {
  get id() {
    return ModuleID.SUPERVISOR
  },
  config(props: Partial<ISupervisorModuleOptions> = {}) {
    deepMergeObject(options, props)
    return SupervisorModule
  },
  get options() {
    return options
  },
  async load() {
    moduleLoaded = true
    return Promise.resolve(SupervisorModule)
  },
  get loaded() {
    return moduleLoaded
  }
}

export default SupervisorModule
